import styles from './login-error-log.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import FullTable from '../full-table/full-table';
import { CreateHeaders, HeaderSizeEnum, PrimaryButton, dateAndTimeHeader, textHeader } from '@frontend-workspace/react-shared-lib';
import ErrorLogModal from '../error-log-dialog/error-log-dialog';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LoginErrorLogProps { }

export function LoginErrorLog(props: LoginErrorLogProps) {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState<string | null>(null);

  const licenseNumberRenderer = (params: ValueFormatterParams) => params.value || t("loginError.noLicense");
  const detailsRenderer = (params: ValueFormatterParams) =>
    <PrimaryButton
      variant="outlined"
      size='small'
      onClick={() => setOpenId(params.value)}>
      {t("loginError.showDetails")}
    </PrimaryButton>

  const headers = CreateHeaders([
    textHeader("id", "ID", HeaderSizeEnum.SMALL, { hide: true }),
    textHeader("errorType", t("standard.errorType"), HeaderSizeEnum.LARGE),
    dateAndTimeHeader("timestamp", t("standard.timestamp")),
    textHeader("email", t("standard.email"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("userName", t("standard.person"), HeaderSizeEnum.LARGE),
    textHeader("companyName", t("standard.companyName"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.MEDIUM),
    textHeader("productName", t("standard.product"), HeaderSizeEnum.LARGE),
    textHeader("productCode", t("standard.productCode"), HeaderSizeEnum.MEDIUM),
    textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM, { renderer: licenseNumberRenderer }),
    textHeader("errorMessage", t("standard.errorText"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("function", t("standard.function"), HeaderSizeEnum.MEDIUM, { hide: true }),
    textHeader("id", "", HeaderSizeEnum.LARGE, {
      renderer: detailsRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
  ])

  return <>
    <FullTable
      headers={headers}
      tableConfigName='loginErrorLog'
      url='licenses/ErrorLogs'
    />
    {openId && <ErrorLogModal
      errorLogId={openId}
      onClose={() => setOpenId(null)}
    />}
  </>
}

export default LoginErrorLog;